import { useEffect } from 'react'

/**
 * ページタイトルを動的に設定するフック
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title
  }, [title])
}
